// extracted by mini-css-extract-plugin
export var container = "FrequentlyAskedQuestions-module__container___RwXHT";
export var header = "FrequentlyAskedQuestions-module__header___r37Yh";
export var dropdownText = "FrequentlyAskedQuestions-module__dropdownText___IczZx";
export var expandable = "FrequentlyAskedQuestions-module__expandable___EP80W";
export var noBottomBorder = "FrequentlyAskedQuestions-module__noBottomBorder___G2JmO";
export var needHelp = "FrequentlyAskedQuestions-module__needHelp___oRNde";